module.exports = __webpack_public_path__ + "img/isencao-taxa-personal.8cd2369e.png";